<div class="banner" style="--bg-url: url({{ backgroundImage }})">
  <h3 class="banner__title">{{ title }}</h3>
  <h2 class="banner__subtitle">{{ subtitle }}</h2>
  <button class="banner__banner-cta" (click)="bannerButtonClick.emit()" *ngIf="showCta && !url" i18n>{{ ctaText }}</button>
  <a [href]="url" class="banner__banner-link" *ngIf="url" i18n>{{ ctaText }}</a>
</div>
